import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import {
  TableRow,
  TableCell,
  TableHead,
  TableContainer,
  TableBody,
  Table,
} from '@material-ui/core';
import PageTitle from '~/components/PageTitle';
import SearchBar from '~/components/SearchBar';
import { T_TitleCell, T_Btn_Function, T_TableRow } from '~/components/TableItem';
import T_common from '~/components/TableItem/common';
import CircleCheckBox from '~/components/CheckBox/CircleCheckBox';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Date, EAA_Memo, EAA_Input, EAA_Add_Btn } from '~/components/EditAndAddItem';
import DefaultObject from './DefaultObject';
import AddAndEdit from './AddAndEdit';

class App extends Component {
  state={
    view_Detail: false,
    mode_Detail: '',
    data_num: undefined,
  }

  onAdd=(o = {}) => {
    const { data, onChange } = this.props;
    data.push(o);
    onChange(data);
  }

  onEdit=(o = {}) => {
    const { data, onChange } = this.props;
    const { data_num } = this.state;
    data[data_num] = o;
    onChange(data);
  }

  _add=() => this.setState({ view_Detail: true, mode_Detail: 'add' })
  _view=i => this.setState({ data_num: i, view_Detail: true, mode_Detail: 'view' })
  _edit=i => this.setState({ data_num: i, view_Detail: true, mode_Detail: 'edit' })
  _delete=i => {
    const { data, onChange } = this.props;
    data.splice(i, 1);
    onChange(data);
  }

  _close_Detail=() => this.setState({ data_num: undefined, view_Detail: false, mode_Detail: '' });

  renderTableTitle=() => {
    const ary = [
      { name: '序號' },
      { name: '港口' },
      { name: '存放碼頭之後線暨鄰近土地' },
      { name: '數量' },
      { name: '單位面積需求' },
      { name: '預計存放空間需求' },
      { name: '實際租用存放空間' },
      { name: '出租方' },
      { name: '已完成簽約' },
      { name: '租賃起始日期' },
      { name: '租賃結束日期' },
      { name: '功能' },
    ];
    return (
      <TableHead>
        <TableRow style={{ height: 48 }}>
          {ary.map((o, i) => (
            <T_TitleCell
              key={i}
              text={o.name}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }

  renderTableBody=() => {
    const { disabled, data, changeData, checkSubChange } = this.props;
    const cellStyle = { fontSize: 14 };

    const returnSign_status = value => {
      switch (value) {
      case '1':return '是';
      case '2':return '否';
      default:return '';
      }
    };

    return (
      <TableBody>
        {data.map((o, i) => (
          <T_TableRow key={i} backgroundColor= {i % 2 === 0 ? '#E0FDFF' : 'white'}>
            <TableCell align='center' style={cellStyle}>{i + 1}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.dock}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.near_land !== '其他' ? o.near_land : `${o.near_land}(${o.near_land_other})`}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.item_num}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.unit_area}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.expect_space}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.rent_space}</TableCell>
            <TableCell align='center' style={cellStyle}>
              {JSON.parse(o.lessor || '[]').map((o2, i2) => (
                <div key={i2} style={{ whiteSpace: 'nowrap', textAlign: 'start' }}>{`${i2 + 1}. ${o2.a !== '其他' ? o2.a : `${o2.a}(${o2.b})`}`}</div>
              ))}
            </TableCell>
            <TableCell align='center' style={cellStyle}>{returnSign_status(o.sign_status)}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.rent_start_date}</TableCell>
            <TableCell align='center' style={cellStyle}>{o.rent_end_date}</TableCell>
            <TableCell style={{ width: 214 }}>
              <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                <T_Btn_Function text='檢視' backgroundColor={T_common.type1} onClick={() => this._view(i)} />
                <T_Btn_Function disabled={disabled} text='編輯' backgroundColor={T_common.type2} onClick={() => this._edit(i)} style={{ marginLeft: 8, marginRight: 8 }} />
                <T_Btn_Function disabled={disabled} text='刪除' backgroundColor={T_common.type3} onClick={() => this._delete(i)} />
              </div>
            </TableCell>
          </T_TableRow>
        ))}
      </TableBody>
    );
  }

  renderTable=() => {
    const { data } = this.props;
    const haveData = data.length > 0;
    return (
      <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
        <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
          {this.renderTableTitle()}
          {haveData && this.renderTableBody()}
        </Table>
      </TableContainer>
    );
  }

  render () {
    const { data, title } = this.props;
    const { view_Detail, mode_Detail, data_num } = this.state;
    const detail_data = !isNaN(data_num) ? data[data_num] : JSON.parse(JSON.stringify(DefaultObject));
    const haveData = data.length > 0;

    return (
      <SearchBar style={{ marginTop: 8 }} text={title}>
        <EAA_Add_Btn onClick={this._add} />
        <this.renderTable />
        {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        {view_Detail && <AddAndEdit title={title} mode={mode_Detail} data={detail_data} onChange={o => !isNaN(data_num) ? this.onEdit(o) : this.onAdd(o)} _onClose={this._close_Detail} />}
      </SearchBar>
    );
  }
}

export default App;
